import { ContactForm } from "@/pages/sections/ContactForm";
import { WhatHappensNext } from "@/pages/sections/WhatHappensNext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Mail } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function ContactPage() {
  const { t } = useI18n();
  return (
    <div data-testid="contact-page">
      <section className="bg-wafa-cream/40">
        <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
          <div className="max-w-3xl">
            <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">Contact</div>
            <h1 className="mt-3 font-heading text-4xl font-semibold tracking-tight text-wafa-deep sm:text-5xl lg:text-6xl">
              Talk to an engineer, not a call centre.
            </h1>
            <p className="mt-5 max-w-2xl text-base text-wafa-ink/80 lg:text-lg">
              Fill in the form below, or reach us directly. We answer inside one business day.
            </p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2">
            <a
              href={`mailto:${t.contact.email}`}
              className="rounded-lg border border-wafa-deep/10 bg-white p-6 hover:-translate-y-1 transition-transform duration-200"
              data-testid="contact-email-card"
            >
              <Mail className="h-5 w-5 text-wafa-primary" />
              <div className="mt-4 text-xs uppercase tracking-wider text-wafa-ink/60">Email</div>
              <div className="mt-1 font-heading text-lg font-semibold text-wafa-deep">{t.contact.email}</div>
              <div className="mt-3 text-xs text-wafa-ink/60">We reply within one business day.</div>
            </a>
            <div className="flex flex-col justify-between rounded-lg border border-wafa-deep/10 bg-white p-6" data-testid="contact-whatsapp-card">
              <div>
                <div className="text-xs uppercase tracking-wider text-wafa-ink/60">WhatsApp</div>
                <div className="mt-1 font-heading text-lg font-semibold text-wafa-deep">Chat with us</div>
                <div className="mt-3 text-xs text-wafa-ink/60">Fastest for quick questions.</div>
              </div>
              <WhatsAppButton className="mt-5 w-full justify-center" source="contact_page" />
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
      <WhatHappensNext />
    </div>
  );
}
